import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../constants/AuthConstants';

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setMobileNumber: (state, action) => {
      state.mobileNumber = action.payload;
    },
    setOTPToken: (state, action) => {
      state.otpToken = action.payload;
    },
    setShowOTPScreen: (state, action) => {
      const { status, phoneNumber, otpToken } = action.payload;

      state.showOTPScreen = status;
      state.mobileNumber = phoneNumber || state.mobileNumber;
      state.otpToken = status ? otpToken : undefined;
      state.isLoading = false;
    },
    setGetOTPSuccess: (state, action) => {
      state.getOTPSuccess = action.payload;
      state.isLoading = false;
    },
    setGetOTPError: (state, action) => {
      state.getOTPError = action.payload;
      state.isLoading = false;
    },
    setVerifyOTPSuccess: (state, action) => {
      state.verifyOTPSuccess = action.payload;
      state.isLoading = false;
    },
    setVerifyOTPError: (state, action) => {
      state.verifyOTPError = action.payload;
      state.isLoading = false;
    },
    setFormLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setGlobalError: (state, action) => {
      state.globalError = action.payload;
    },
    resetGlobalError: state => {
      state.globalError = { message: '' };
    }
  }
});

export const {
  setGetOTPError,
  setGetOTPSuccess,
  setVerifyOTPError,
  setVerifyOTPSuccess,
  setShowOTPScreen,
  setMobileNumber,
  setOTPToken,
  setFormLoading,
  setGlobalError,
  resetGlobalError
} = authSlice.actions;

export default authSlice.reducer;
